/* =========================================================================
   em-upsell.js — Pop-up nach „In den Warenkorb" (012).

   Aufruf aus em-buybox nach erfolgreichem /cart/add.js:
     window.emUpsell({ productId, cart, weiter, heading })
   Holt eine passende Empfehlung aus Shopifys Produktempfehlungen
   (intent=complementary, sonst related), zeigt EIN Produkt, das noch nicht
   im Warenkorb liegt. „Dazulegen" legt es per /cart/add.js dazu; danach —
   und bei „Weiter", Escape, Klick daneben oder jedem Fehler — laeuft
   `weiter()` (oeffnet die Schublade). Ohne Skript passiert einfach das,
   was vorher passierte.
   ========================================================================= */
(function () {
  "use strict";
  if (window.emUpsell) return;

  /* 24.09.2026 (014b): Trennzeichen und Waehrungszeichen kommen aus dem
     Format der Anzeigewaehrung, das theme-object.liquid bereitstellt.
     Vorher stand hier fest ein Komma und ein Euro — im Schweizer Upsell
     ergab das "96,00 €" fuer einen Betrag in Franken. */
  function geld(cents) {
    var fmt = (window.Theme && Theme.moneyFormat) || '';
    var v = (cents / 100).toFixed(2);
    if (fmt.indexOf('comma_separator') !== -1) { v = v.replace('.', ','); }
    var sym = fmt.replace(/\{\{[\s\S]*?\}\}/g, '').trim();
    if (!sym) {
      sym = (window.Shopify && Shopify.currency && Shopify.currency.active) || '€';
    }
    return v + '\u00a0' + sym;
  }

  function bild(p) {
    var src = (p.featured_image || (p.images && p.images[0]) || '');
    if (typeof src === 'object' && src.src) src = src.src;
    if (!src) return '';
    return src.replace(/(\.[a-z]{3,4})(\?|$)/i, '_600x$1$2');
  }

  function bauen(p, heading, weiter) {
    var alt = document.querySelector('.em-upsell');
    if (alt) alt.remove();
    var v = null;
    for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
    if (!v) { weiter(); return; }

    var wrap = document.createElement('div');
    wrap.className = 'em-upsell';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'em-upsell-titel');
    wrap.innerHTML =
      '<div class="em-upsell__back" data-em-upsell-weiter></div>' +
      '<div class="em-upsell__card">' +
        '<button type="button" class="em-upsell__x" aria-label="Schließen" data-em-upsell-weiter>&times;</button>' +
        '<div class="em-upsell__ok"><span aria-hidden="true">✓</span> Im Warenkorb</div>' +
        '<div class="em-upsell__body">' +
          '<a class="em-upsell__media" href="' + p.url + '">' + (bild(p) ? '<img src="' + bild(p) + '" alt="" loading="eager">' : '') + '</a>' +
          '<div class="em-upsell__text">' +
            '<span class="em-eyebrow">' + heading + '</span>' +
            '<h2 class="em-h3" id="em-upsell-titel">' + p.title.split(' | ')[0].split(' I ')[0] + '</h2>' +
            '<p class="em-upsell__price">' + geld(v.price) +
              (v.compare_at_price && v.compare_at_price > v.price ? ' <s>' + geld(v.compare_at_price) + '</s>' : '') + '</p>' +
            '<div class="em-upsell__cta">' +
              '<button type="button" class="em-btn em-upsell__add" data-em-upsell-add="' + v.id + '">Dazulegen</button>' +
              '<button type="button" class="em-upsell__skip" data-em-upsell-weiter>Weiter zum Warenkorb <span aria-hidden="true">→</span></button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(wrap);
    document.documentElement.classList.add('em-upsell-offen');
    setTimeout(function () { wrap.classList.add('is-in'); }, 20);

    var fertig = false;
    function schliessen(cb) {
      if (fertig) return; fertig = true;
      wrap.classList.remove('is-in');
      document.documentElement.classList.remove('em-upsell-offen');
      document.removeEventListener('keydown', esc);
      setTimeout(function () { wrap.remove(); cb(); }, 220);
    }
    function esc(e) { if (e.key === 'Escape') schliessen(weiter); }
    document.addEventListener('keydown', esc);

    wrap.addEventListener('click', function (e) {
      var w = e.target.closest('[data-em-upsell-weiter]');
      if (w) { schliessen(weiter); return; }
      var a = e.target.closest('[data-em-upsell-add]');
      if (a) {
        a.disabled = true; a.classList.add('is-busy');
        fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: Number(a.getAttribute('data-em-upsell-add')), quantity: 1 }] })
        }).then(function () { schliessen(weiter); }).catch(function () { schliessen(weiter); });
      }
    });
    var first = wrap.querySelector('.em-upsell__add');
    if (first) first.focus();
  }

  window.emUpsell = function (o) {
    var weiter = typeof o.weiter === 'function' ? o.weiter : function () {};
    if (!o || !o.productId || !window.fetch) { weiter(); return; }
    var imKorb = {};
    ((o.cart && o.cart.items) || []).forEach(function (it) { imKorb[it.product_id] = true; });
    var heading = o.heading || 'Passt dazu';

    function laden(intent) {
      return fetch('/recommendations/products.json?product_id=' + o.productId + '&limit=8&intent=' + intent, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return (d.products || []).filter(function (p) { return p.available && !imKorb[p.id] && p.id !== o.productId; }); });
    }
    var timer = setTimeout(function () { timer = null; weiter(); }, 2500);
    laden('complementary').then(function (list) {
      if (list.length) return list;
      return laden('related');
    }).then(function (list) {
      if (timer === null) return;           /* zu spaet — Schublade laeuft schon */
      clearTimeout(timer);
      if (!list.length) { weiter(); return; }
      bauen(list[0], heading, weiter);
    }).catch(function () { if (timer !== null) { clearTimeout(timer); weiter(); } });
  };
})();
